;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var CARDINAL_ORIGIN = /^https:\/\/([a-z0-9-]+\.)*(cardinalcommerce\.com|cardinaltrusted\.com)$/i;

var COLLECTION_TIMEOUT_MS = 10000;

exports.default = {
    props: ["url", "token", "origin"],
    data: function data() {
        return { done: false, timer: null };
    },
    mounted: function mounted() {
        var _this = this;

        window.addEventListener("message", this.handleMessage, false);
        this.timer = setTimeout(function () {
            return _this.finish({ Status: false, timedOut: true });
        }, COLLECTION_TIMEOUT_MS);
        this.submitForm();
    },

    methods: {
        submitForm: function submitForm() {
            this.$refs.collectionForm.submit();
        },
        isCardinalOrigin: function isCardinalOrigin(origin) {
            return origin === this.origin || CARDINAL_ORIGIN.test(origin);
        },
        handleMessage: function handleMessage(event) {
            if (!this.isCardinalOrigin(event.origin)) return;

            var data = event.data;
            if (typeof data === "string") {
                try {
                    data = JSON.parse(data);
                } catch (e) {}
            }
            if (data && data.MessageType && data.MessageType !== "profile.completed") return;

            this.finish(data);
        },
        finish: function finish(data) {
            if (this.done) return;
            this.done = true;
            clearTimeout(this.timer);
            this.$emit("enrollmentChecked", data);
        }
    },
    beforeDestroy: function beforeDestroy() {
        clearTimeout(this.timer);
        window.removeEventListener("message", this.handleMessage, false);
    }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{ref:"collectionIframe",staticStyle:{"display":"none"},attrs:{"name":"collectionIframe","height":"10","width":"10"}}),_vm._v(" "),_c('form',{ref:"collectionForm",attrs:{"method":"POST","target":"collectionIframe","action":_vm.url}},[_c('input',{attrs:{"type":"hidden","name":"JWT"},domProps:{"value":_vm.token}})])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5f235c3c", __vue__options__)
  } else {
    hotAPI.reload("data-v-5f235c3c", __vue__options__)
  }
})()}